import { NIVEL_SUPERIOR, NIVEL_TECNICO } from 'types/NivelCbo'

export const grupoCboListaProblemasCondicoes = {
  visualizar: [...NIVEL_TECNICO, ...NIVEL_SUPERIOR],
  adicionar: [...NIVEL_SUPERIOR],
}
